import type { ServiceUnavailableTranslation } from './serviceUnavailable.translation.pl.ts';

export const serviceUnavailableTranslation: ServiceUnavailableTranslation = {
  message: "Nous n'acceptons pas de candidatures de stage pour le moment - à bientôt en mars",
};
